export const AiSummariesRoute = {
  AISUMMARIES: 'aisummaries',
};

export const AiSummariesPathName = {
  AISUMMARIES: 'aisummaries',
};

export const ChatGptUserRoles = {
  USER: 'user',
  SYSTEM: 'system',
  ASSISTANT: 'assistant',
};

export const ChatGptUserNames = {
  USER: 'USER',
  SYSTEM: 'SYSTEM',
  ASSISTANT: 'AI AGENT',
};

export function GetChatGptDisclaimerText() {
  return i18n.$t(
    'Note: AI-supported responses are generated using emerging technologies. Results should be reviewed and verified before being shared externally or used for campaign or business decisions. No guarantees are made regarding the accuracy, completeness, or appropriateness of the information presented.'
  );
}

export function GetHumanCuratedCheckMessage() {
  return i18n.$t('Mark as Human Verified before adding to Executive Summary');
}

export const TimerSessionKey = 'chatgpt-summary-timer';
export const TimerSessionValues = {
  SHOW: 'show',
  HIDE: 'hide',
};

export const GptWidget = {
  NEW_THREAD_ID: 'NEW_GPT_THREAD_ID',
};

export const ListTypes = {
  DASHBOARD: 'dashboard',
  REPORT_STUDIO: 'report_studio',
};

// Stable key of the internal, hidden "Ask Your Dashboard" agent used to associate
// SmartSlides created from Ask Your Dashboard conversations.
export const AskYourDashboardAgentKey = 'ask_your_dashboard';

export const ChatGptSummariesEvents = {
  RESET_ROUTE_DATA: 'reset-route-data',
  CLOSE_PARENT_MODAL: 'close-parent-modal',
};
